export class PagedResult {
  public TotalCount: number;
  public TotalPages: number;
  public CurrentPageNumber: number;
  public PageSize: number;
  public Result: any[];

  public constructor() {
    this.TotalCount = 0;
    this.TotalPages = 0;
    this.CurrentPageNumber = 0;
    this.PageSize = 0;
    this.Result = [];
  }
}

export interface PagedResultGeneric<T> {
  TotalCount: number;
  TotalPages: number;
  CurrentPageNumber: number;
  PageSize: number;
  Result: T[];
}

export interface ServicePagedResult<T> {
  totalCount: number;
  totalPages: number;
  currentPageNumber: number;
  pageSize: number;
  result: T[];
}
